import React from 'react';
import { X, Wallet } from 'lucide-react';

const BalanceAdjustDialog = ({ customer, balance, form, setForm, onConfirm, onClose, loading }) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="p-5 border-b flex justify-between items-center">
          <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <Wallet className="w-5 h-5 text-blue-600" />手动调整余额
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-sm text-gray-600">
            客户：<span className="font-medium">{customer.name || customer.username}</span>
            <span className="ml-2 text-green-600 font-medium">
              当前余额 ${parseFloat(balance || 0).toFixed(2)}
            </span>
          </p>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">操作类型</label>
            <div className="grid grid-cols-3 gap-2">
              {[
                { value: 'recharge', label: '充值', color: 'bg-green-500' },
                { value: 'consume',  label: '扣款', color: 'bg-red-500' },
                { value: 'withdraw', label: '提币', color: 'bg-orange-500' },
              ].map(t => (
                <button key={t.value} type="button"
                  onClick={() => setForm({ ...form, type: t.value })}
                  className={`py-2 rounded-lg text-sm font-medium text-white transition-colors ${
                    form.type === t.value ? t.color : 'bg-gray-200 text-gray-600'
                  }`}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">金额 (USDT)</label>
            <input type="number" min="0" step="0.01" value={form.amount}
              onChange={e => setForm({ ...form, amount: e.target.value })}
              placeholder="0.00"
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">备注</label>
            <input type="text" value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
              placeholder="调整原因..."
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500" />
          </div>
        </div>
        <div className="p-5 border-t flex gap-3">
          <button onClick={onClose}
            className="flex-1 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
            取消
          </button>
          <button onClick={onConfirm} disabled={loading}
            className="flex-1 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
            {loading ? '处理中...' : '确认调整'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BalanceAdjustDialog;